import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Anchor, Button} from "../index";
import {THEME} from "../config/FusionConfig";
import {changeStringCase, checkNullArr, checkNullStr, getArrLen, getJsonValue, getDefStr, isBoolTrue, isJsonValueTrue} from "../utils/ReactUtils";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";

/**
 * Create button-dropdown component.
 *
 * @example
 *    const DROPDOWN_ITEMS=[
 *          item1: {
 *             name: 'Dropdown Item 1',
 *             icon: 'bi bi-app-indicator',
 *             iconRight: 'bi bi-alexa',
 *         },
 *         item2: {
 *             name: 'Dropdown Item 1',
 *             icon: 'bi bi-app-indicator',
 *             iconRight: 'bi bi-alexa',
 *         },
 *    ];
 * <ButtonDropdown
 *                 className={``}
 *                 buttonClassName={`border-none highlight-theme-full-hover text-white-hover`}
 *                 itemClassName={``}
 *                 variant={'primary'}
 *                 buttonVariant={'primary'}
 *                 selectedItemBgVariant={'primary'}
 *                 selectedItemColorVariant={'light'}
 *                 outlined={outlined}
 *                 defOption={defOption}
 *                 onMenuItemClick={(name, index=>{
 *                     console.log('onMenuItemClick.name:', name, 'index:', index);
 *                 })}
 *                 buttonStyle={{}}
 *                 dropdownStyle={{}}
 *                 itemStyle={{}}
 *                 itemSelectedStyle={{}}
 *                 itemHoverStyle={{}}
 *                 itemPressStyle={{}}
 *                 {...rest}>
 *                 {DROPDOWN_ITEMS}
 *             </ButtonDropdown>
 */
const ButtonDropdown = ({
                            className = "",
                            buttonClassName = "",
                            itemClassName = "",
                            dividerClassName = "",


                            wrapperStyle = {},
                            menuStyle = {},
                            style = {},
                            dropdownStyle = {},
                            buttonStyle = {},
                            buttonHoverStyle = {},
                            buttonTouchStyle = {},
                            buttonPressStyle = {},
                            itemStyle = {},
                            itemSelectedStyle = {},
                            itemHoverStyle = {},
                            itemPressStyle = {},
                            dividerStyle = {},

                            variant = THEME,
                            buttonVariant = 'dark',

                            selectedItemBgVariant = THEME,
                            selectedItemColorVariant = 'white',

                            disabled,
                            enableFocusStyling = false,
                            outlined = true,
                            showSelectedOption = true,
                            enableRedirect = false,
                            simpleLink = true,
                            defOption = 'Button Dropdown',
                            textPrefix,
                            textPostfix,
                            textWrap = '',
                            tooltip = '',
                            children,

                            menuItemIdKey = 'id',
                            menuItemNameKey = 'name',
                            menuItemLinkKey = 'link',
                            dividerKey = 'divider',
                            highlightableKey = 'highlightable',

                            onMenuShow,
                            onMenuHide,
                            onMenuItemClick,
                            onExpand,
                            ...rest
                        }) => {
    const TAG = "ButtonDropdown";

    const [currMenuItemName, setCurrMenuItemName] = useState();

    const [itemHoverData, setItemHoverData] = useState({hover: false, name: null});
    const [itemPressedData, setItemPressedData] = useState({hover: false, name: null});

    const [anchorEl, setAnchorEl] = useState(null);
    const openMenu = Boolean(anchorEl);

    // useEffect(() => {
    //     console.log(TAG, 'useEffect.children:', children);
    // }, [children]);
    useEffect(() => {
        // console.log(TAG, 'useEffect.defOption:', defOption);
        setCurrMenuItemName(defOption);
    }, [defOption]);
    //button dropdown
    // https://codepen.io/ig_design/pen/MWKVrNR
    //
    // cool popover
    // https://codepen.io/garetmckinley/pen/XvgzKQ
    // https://bbbootstrap.com/snippets/user-menu-dropdown-79326910

    return (<>
        {/*<div*/}
        {/*    className={`p-0 m-0 ${className} overflow-hidden`}*/}
        {/*    style={{...wrapperStyle}}*/}
        {/*>*/}
        <Button
            className={`${buttonClassName} px-2py-1 rounded-2x text-${buttonVariant} text-nowrap shadow-none border-grayx`}
            variant={''}
            color={''}
            rounded={false}
            style={buttonStyle}
            hoverStyle={buttonHoverStyle}
            touchStyle={buttonTouchStyle}
            pressStyle={buttonPressStyle}
            backgroundColor={'x'}
            outlined={outlined}
            disabled={disabled}
            tooltip={checkNullStr(anchorEl) ? '' : tooltip}
            enableFocusStyling={enableFocusStyling}
            text={<span className={`text-${textWrap}`}>
                {checkNullStr(textPrefix) && <span>{textPrefix}</span>}
                {isBoolTrue(showSelectedOption) && <span>{" "}{currMenuItemName}</span>}
                {(checkNullStr(textPostfix) && isBoolTrue(showSelectedOption)) && <span>{" "}{textPostfix}</span>}
            </span>}
            iconAtEnd={true}
            iconClass={`${openMenu ? `fa fa-angle-up` : `fa fa-angle-down`} ps-2 text-${buttonVariant}`}
            onClick={(e) => {
                setAnchorEl(e.currentTarget);
                if (onExpand) onExpand(true);
            }}
            {...rest}
        />
        {/*</div>*/}

        {createMenu()}
    </>)

    function createMenu() {
        return <Menu
            className={"mt-1x"}
            anchorEl={anchorEl}
            open={openMenu}
            onClose={() => {
                setAnchorEl(null);
                if (onExpand) onExpand(false);
            }}
            PaperProps={{
                style: {
                    boxShadow: "var(--shadow)",
                    borderRadius: ".6rem",
                    width: 'auto',
                    padding: '.8rem .6rem',
                    marginTop: '.1rem',
                    ...dropdownStyle,

                }
            }}
            sx={{
                '& .MuiPaper-root': {
                    backgroundColor: "var(--bodyColor)",
                },
            }}>
            {/*<GridBox className={'w-50'} sm={12} md={6}>*/}
            {checkNullArr(children) && children.map((item, index) => {
                return createMenuItem(item, index)
                // {(index != getArrLen(children) - 1 && addSep)
                //     && <hr className={`w-100 p-0 ${dividerClassName}`}
                //            style={{
                //                border: `1px solid ${variant}`,
                //                margin: '.1rem 0',
                //            }}/>}
                // </>
            })}
            {/*</GridBox>*/}
        </Menu>
    }

    function createMenuItem(item, index) {
        const itemLink = getJsonValue(item, menuItemLinkKey);
        const asLink = checkNullStr(itemLink);
        const name = getDefStr(getJsonValue(item, menuItemNameKey), item) + '';
        const id = getDefStr(getJsonValue(item, menuItemIdKey), getJsonValue(item, menuItemNameKey, index)) + '';
        const style = getJsonValue(item, 'style', {});
        const itemVariant = getJsonValue(item, 'variant', variant);
        const color = getJsonValue(item, 'color');
        const selectedBg = getJsonValue(item, 'selectedBg', selectedItemBgVariant);
        const selectedColor = getJsonValue(item, 'selectedColor', selectedItemColorVariant);
        const highlightable = isBoolTrue(getJsonValue(item, highlightableKey, true));
        const asLoading = isJsonValueTrue(item, 'loading');
        const disabled = isJsonValueTrue(item, 'disabled');
        const addSep = isJsonValueTrue(item, dividerKey);
        const leftIconFound = checkNullStr(getDefStr(getJsonValue(item, 'icon'), getJsonValue(item, 'iconLeft')));
        const rightIconFound = checkNullStr(getJsonValue(item, 'iconRight'));
        const selected = name == currMenuItemName;

        const itemStyles = {
            marginBottom: (index == getArrLen(children) - 1 || addSep) ? '0' : '.1rem',
            color: selected ? selectedColor : color,
            backgroundColor: selected ? selectedBg : 'transparent', ...style, ...itemStyle, ...(isBoolTrue(asLoading) || isBoolTrue(disabled)) ? {} : {
                ...(itemHoverData.hover && itemHoverData.name == name) ? itemHoverStyle : {}, ...(itemPressedData.hover && itemPressedData.name == name) ? itemPressStyle : {},
            }, ...selected ? itemSelectedStyle : {},
        };

        //Using "<> <MenuItem> children </MenuItem> </>" give this warning: The Menu component doesn't accept a Fragment as a child.
        // return <>
        return <MenuItem
            className={`highlight-${itemVariant}-full-hover highlight-${itemVariant}-full-focus highlight-${itemVariant}-full-active 
                    text-${selectedColor}-hover text-${selectedColor}-focus
                    ${asLink ? 'm-0 p-0 w-100' : getPadClass()}
                    text-${getJsonValue(item, 'variant', color)} ${itemClassName} transition-none`}
            key={index + id}
            selected={highlightable ? selected : null}
            onClick={() => handleMenuItemClick(name, index, item)}
            style={itemStyles}
            onFocus={() => setItemHoverData({hover: true, name: name})}
            onMouseEnter={() => setItemHoverData({hover: true, name: name})}
            onMouseLeave={() => setItemHoverData({hover: false, name: null})}
            onMouseDown={() => setItemPressedData({hover: false, name: null})}
            onMouseUp={() => setItemPressedData({hover: false, name: null})}
            sx={itemStyles}>
            <span className={'d-flex fd-row flex-nowrap jc-between al-center w-100 xbg-warning'}>
                <span className={'d-flex fd-row flex-nowrap jc-start al-center w-100 xbg-danger'}>
                            {/*{leftIconFound && <i className={`${getDefStr(getJsonValue(item, 'icon'), getJsonValue(item, 'iconLeft'))} me-2`}/>}*/}

                    {/*as-anchor*/}
                    {asLink ? <div
                        className={'d-flex w-100 bg-infox'}>
                        <Anchor
                            wrapperClassName={'w-100 bg-dangerx m-0 p-0'}
                            asLink={false}
                            simple={isBoolTrue(simpleLink)}
                            className={`w-100 m-0 p-0 ${getPadClass()}`}
                            href={itemLink}
                            target={getJsonValue(item, 'target')}
                            onClick={(e) => {
                                if (!isBoolTrue(enableRedirect)) e.preventDefault();
                            }}
                        >
                            <span>{changeStringCase(name, 'capitalize', true)}</span>
                        </Anchor>
                    </div> : <span>{changeStringCase(name, 'capitalize', true)}</span>}
                </span>
                {/*{rightIconFound && <i className={`${getJsonValue(item, 'iconRight')} ms-2`}/>}*/}
            </span>
        </MenuItem>

        function getPadClass() {
            return `py-1 px-2 rounded-4 select-none ${!leftIconFound ? 'ps-3' : ''} ${!rightIconFound ? 'pe-3' : ''}`;
        }
    }

    function handleMenuItemClick(name, index, item) {
        setAnchorEl(null);
        if (onExpand) onExpand(false);
        setCurrMenuItemName(name);
        if (onMenuItemClick) onMenuItemClick(name, index, item);
    }
}
ButtonDropdown.propTypes = {
    className: PropTypes.string, wrapperStyle: PropTypes.object, style: PropTypes.object,
};
export default ButtonDropdown;
